import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getNeverbounceConfigurationState = createSelector(
  getDragonflyState,
  (state) => state?.neverbounceConfiguration,
);

export const getNameNeverbounce = createSelector(getNeverbounceConfigurationState, (state) => state?.nameNeverbounce);

export const getStatusNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.statusNeverbounce,
);

export const getNotificationEmailNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.notificationEmailNeverbounce,
);

export const getJobMaxSizeNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.jobMaxSizeNeverbounce,
);

export const getResultTypesNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.resultTypesNeverbounce,
);

export const getBaseUrlNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.baseUrlNeverbounce,
);

export const getReadTimeoutNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.readTimeoutNeverbounce,
);

export const getConnectionTimeoutNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.connectionTimeoutNeverbounce,
);

export const getApiKeyNeverbounce = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.apiKeyNeverbounce,
);

export const getShowUpdateBtn = createSelector(getNeverbounceConfigurationState, (state) => state?.showUpdateBtn);

export const getDisableNameValue = createSelector(getNeverbounceConfigurationState, (state) => state?.disableName);

export const getRootConfigurationHelpTextStatus = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.rootConfigurationHelpTextStatus,
);

export const getCredentialsConfigurationHelpTextStatus = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.credentialsConfigurationHelpTextStatus,
);

export const getEndpointConfigurationHelpTextStatus = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.endpointConfigurationHelpTextStatus,
);

export const getSelectedNeverbounceDataFromGrid = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.selectedNeverbounceDataFromGrid,
);

export const getShowCancelBtn = createSelector(getNeverbounceConfigurationState, (state) => state?.showCancelBtn);

export const getNeverbounceDataIsSubmitted = createSelector(
  getNeverbounceConfigurationState,
  (state) => state?.isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(
  getNameNeverbounce,
  getNeverbounceDataIsSubmitted,
  (name, dataIsSubmitted) => (!name && dataIsSubmitted ? true : false),
);

export const getShowJobMaxSizeErrorMsg = createSelector(
  getJobMaxSizeNeverbounce,
  getNeverbounceDataIsSubmitted,
  (jobMaxSize, dataIsSubmitted) => (jobMaxSize === null && dataIsSubmitted ? true : false),
);

export const getShowBaseUrlErrorMsg = createSelector(
  getBaseUrlNeverbounce,
  getNeverbounceDataIsSubmitted,
  (url, dataIsSubmitted) => (!url && dataIsSubmitted ? true : false),
);

export const getShowJobMaxSizeErrorValueMsg = createSelector(
  getJobMaxSizeNeverbounce,
  getNeverbounceDataIsSubmitted,
  (jobMaxSize, dataIsSubmitted) => (jobMaxSize !== null && jobMaxSize < 1000 && dataIsSubmitted ? true : false),
);

export const getShowApiKeyErrorMsg = createSelector(
  getApiKeyNeverbounce,
  getNeverbounceDataIsSubmitted,
  getShowUpdateBtn,
  (apiKey, dataIsSubmitted, isEditMode) => (!apiKey && dataIsSubmitted && !isEditMode ? true : false),
);

export const getNeverbounceDataAreValid = createSelector(
  getNameNeverbounce,
  getBaseUrlNeverbounce,
  getApiKeyNeverbounce,
  getJobMaxSizeNeverbounce,
  getShowUpdateBtn,
  (name, baseURL, apiKey, jobMaxSize, isEditMode) =>
    name && baseURL && (apiKey || isEditMode) && jobMaxSize !== null && jobMaxSize >= 1000 ? true : false,
);
